module.exports = __webpack_public_path__ + "static/img/email.aa8d37e2.png";